$(document).ready(function () {
    const jexcel = require('jexcel');
    const baseUrl = $("#app_url").val();

    let masterTableRows = [];
    let masterTableHeader = [];
    let googleImport = {
        market: {},
        client: {},
        two: {
            header: [],
            rows: [],
            table: {}
        },
        three: {
            programNames: [],
            createdDates: [],
            dropdownProgramNames: [],
        },
        four: {
            header: [],
            rows: []
        }
    };

    let masterTableRowsChanged = function (instance, cell, x, y, value) {
        masterTableRows[y][x] = value;
    };

    let getSpreedSheet = (sheet_id) => {
        if (sheet_id) {
            $.ajax({
                type: 'GET',
                url: baseUrl + 'get-sheets/' + sheet_id + '/',
                processData: false,
                contentType: 'application/json',
                success: function (data) {
                    if (data.success) {
                        $('#next-by-button').show();
                        $('#next-by-login').hide();

                        let dropdown = $("#sheet_name");
                        dropdown.html('');
                        $.each(data.sheets, function (key, sheet) {
                            dropdown.append($("<option />").val(sheet).text(sheet));
                        });
                    } else {
                        $('#next-by-login').show();
                        $('#next-by-button').hide();
                    }
                },
            });
        }
    };

    let nameOrEmpty = (string) => {
        return string === null ? '' : string;
    };

    let displayLeadsToAdsTable = () => {
        let table = $('<table border="1" class="leads-to-ads"></table>');

        //Create table header
        let thead = $('<thead></thead>');
        let theadTr = $('<tr></tr>');
        for (let i = 0; i < googleImport.four.header.length; i++) {
            theadTr.append($('<th>' + googleImport.four.header[i] + '</th>'))
        }
        thead.append(theadTr);

        //Create table body
        let tbody = $('<tbody></tbody>');

        for (let i = 0; i < Object.keys(googleImport.four.rows).length; i++) {
            let row = googleImport.four.rows[i];
            let tr = $('<tr></tr>');
            let programTd = $('<td></td>');

            if (row['closets']['is'] === 'ad') {
                programTd.html(nameOrEmpty(row['closets']['name']));
            }
            else {
                tr.attr('data-is', row['closets']['is']);
                tr.attr('data-index', row['index']);
                tr.attr('data-ad_index', row['closets']['ad_index']);

                let programSelect = $('<select data-live-search="true"></select>');
                for (let a = 0; a < row['closets']['items'].length; a++) {
                    let item = row['closets']['items'][a];
                    let option = $('<option data-index="' + item['index'] + '">' + nameOrEmpty(item['name']) + '</option>');

                    if (row['closets']['ad_index'] === item['index']) {
                        option.attr('selected', 'selected');
                    }

                    programSelect.append(option);
                }
                programTd.append(programSelect);
            }

            let dateTd = $('<td class="date">' + nameOrEmpty(row['date']) + '</td>');
            let spotPhoneTd = $('<td class="spotPhone">' + nameOrEmpty(row['spotPhone']) + '</td>');
            let stationId = $('<td class="spotPhone">' + nameOrEmpty(row['stationId']) + '</td>');
            let networkId = $('<td class="spotPhone">' + nameOrEmpty(row['networkId']) + '</td>');
            let rateGross = $('<td class="spotPhone">' + nameOrEmpty(row['rateGross']) + '</td>');
            let phoneCalledTd = $('<td class="phoneCalled">' + nameOrEmpty(row['phoneCalled']) + '</td>');

            tr.append(dateTd);
            tr.append(stationId);
            tr.append(networkId);
            tr.append(programTd);
            tr.append(spotPhoneTd);
            tr.append(phoneCalledTd);
            tr.append(rateGross);

            tbody.append(tr);
        }

        //Append header and body to table
        table.append(thead);
        table.append(tbody);

        $('#gi-tab-4-table').html(table);
        $("#gi-tab-4-table .leads-to-ads select").selectpicker();
    };

    $(document).on('click', '#show-csv-file-data-master', function (e) {
        $('#google_login_button').hide();
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();
        let form = $('#csv-file-form-master');
        let action = form.attr('action');
        let formData = new FormData(form[0]);

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,

            success: function (data) {
                if (data.success) {
                    $('#csv-error-messages').hide(200);
                    $('#csv-file-table-tab-link').tab('show');
                    $('#csv-file-save-info-messages').hide();

                    if (data.client || data.marketId) {
                        messages = [];

                        if (data.client) {
                            messages.push(`Selected Client is ${data.client.client_name} (${data.client.client_id})`);
                        }
                        if (data.marketId) {
                            messages.push(`Selected Market ID is ${data.marketId}`);
                        }

                        if (data.fileName) {
                            $('#csv-file-id').val(data.fileName)
                        }

                        $('#csv-file-save-info-messages').html(messages.join('<br>')).fadeIn();
                    }

                    masterTableHeader = data.header;
                    masterTableRows = data.rows;

                    let jexcelColumns = [];

                    for (let item of data.header) {
                        jexcelColumns.push({
                            type: 'text',
                            title: item,
                            width: 100
                        });
                    }

                    jexcel.destroy(document.getElementById('csv-file-table-master'), false);

                    $('#csv-file-table-master').jexcel({
                        lazyLoading: true,
                        loadingSpin: true,
                        columnSorting: false,
                        tableOverflow: true,
                        allowInsertColumn: false,
                        allowDeleteColumn: false,
                        allowInsertRow: false,
                        allowDeleteRow: false,
                        csvHeader: true,
                        tableWidth: "70vw",
                        tableHeight: "70vh",
                        columns: jexcelColumns,
                        data: masterTableRows,
                        onchange: masterTableRowsChanged,
                    });

                } else {
                    $('#csv-error-messages').html(data.errors.join('<br>')).fadeIn();
                    if (data.error_code == "google_auth") {
                        $('#google_login_button').show();
                    }
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });

    });

    $(document).on('click', '#save-csv-file-data-master', function (e) {
        e.preventDefault();

        let button = $(this);
        let backButton = $('#show-csv-file-form');

        button.attr('disabled', true);
        backButton.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let saveForm = $('#save-csv-file-form-master');
        let action = saveForm.attr('action');

        $.ajax({
            type: 'POST',
            url: action,
            data: JSON.stringify({
                master_header: JSON.stringify(masterTableHeader),
                master_rows: JSON.stringify(masterTableRows),
                client_id: $('#import-client-id').val(),
                market_id: $('#import-market-id').val(),
                csv_file: $('#csv-file-id').val(),
            }),
            processData: false,
            contentType: 'application/json',

            success: function (data) {
                button.attr('disabled', false);
                backButton.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();

                if (data.success) {
                    $('#csv-file-save-success-messages').html(data.messages.join('<br>')).fadeIn();
                    $('#csv-file-save-error-messages').hide(200);
                    $('#csv-file-messages-tab-link').tab('show');

                } else {
                    $('#csv-file-save-error-messages').html(data.errors.join('<br>')).fadeIn();
                }
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    $(document).on('click', '#show-csv-file-form-master', function (e) {
        $('#csv-file-save-error-messages').hide(200);
        $('#csv-file-form-tab-link').tab('show');
    });

    $(document).on('change', '#import_type', function (e) {
        if ($(this).val() == 'csv') {
            $('#csv-file-upload').show();
            $('#excel-file-upload').hide();
            $('#google_login_button').hide();
        } else {
            $('#excel-file-upload').show();
            $('#csv-file-upload').hide();
        }
    });

    //Google spreed sheet
    $(document).on('change', '#spreadsheet-input', function (e) {
        getSpreedSheet($(this).val());
    });

    //Select market and client
    $(document).on('change', '#import-market-client', function () {
        let option = $('#import-market-client option:selected');

        $('#import-market-id').val(option.data('market_id'));
        $('#import-client-id').val(option.data('client_id'));

        if (option.data('sheet_id')) {
            $('#spreadsheet-input').val(option.data('sheet_id'));
            getSpreedSheet(option.data('sheet_id'));
        }
    });

    //Google import
    $('body').on('change', '#program-names .bootstrap-select select', function () {
        let value = $(this).val();
        let input = $(this).parents('.program-name-item').find('.input-area input');
        input.val(value);
    });

    $(document).on('click', '#next-gi-tab-2', function (e) {
        e.preventDefault();
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        $('#gi-tab-2-table').html('');

        let form = $('#gi-tab-1-form');
        let action = form.attr('action');
        let formData = new FormData(form[0]);

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,

            success: function (data) {
                if (data.success) {
                    googleImport.market = data.market;
                    googleImport.client = data.client;

                    googleImport.two.header = data.header;
                    googleImport.two.rows = data.rows;
                    googleImport.two.table = data.table;

                    googleImport.three.programNames = data.programNames;
                    googleImport.three.createdDates = data.createdDates;
                    googleImport.three.dropdownProgramNames = data.dropdownProgramNames;

                    let messages = [
                        `Selected Market is ${googleImport.market['market_name']} (${googleImport.market['market_id']})`,
                        `Selected Client is ${googleImport.client['client_name']} (${googleImport.client['client_id']})`
                    ];

                    $('#gi-tab-1-errors').hide(200);
                    $('#gi-tab-2-messages').html(messages.join('<br>')).fadeIn();
                    $('#gi-tab-2-errors').hide();
                    $('#gi-tab-2-table').html(googleImport.two.table);
                    $('#gi-tab-2-link').tab('show');
                    filterOptions();
                }
                else {
                    $('#gi-tab-1-errors').html(data.errors.join('<br>')).fadeIn();
                    if (data['error_code'] === "google_auth") {
                        $('#next-by-button').hide();
                        $('#next-by-login').show();
                    }
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    $(document).on('click', '#back-gi-tab-1', function (e) {
        e.preventDefault();
        $('#gi-tab-1-link').tab('show');
    });

    $(document).on('click', '#next-gi-tab-3', function (e) {
        e.preventDefault();

        if (Object.keys(googleImport.three.programNames).length > 0) {
            let button = $(this);
            let backButton = $('#back-gi-tab-1');
            button.attr('disabled', true);
            backButton.attr('disabled', true);
            button.find('.fa').hide();
            button.find('.fa-spinner').show();

            let action = button.data('action');
            let formData = new FormData();

            formData.append('market_id', googleImport.market['market_id']);
            formData.append('client_id', googleImport.client['client_id']);
            formData.append('master_header', JSON.stringify($('#csv-file-table-form').serializeArray()));
            formData.append('master_rows', JSON.stringify(googleImport.two.rows));

            $.ajax({
                type: 'POST',
                url: action,
                enctype: 'multipart/form-data',
                data: formData,
                processData: false,
                contentType: false,
                cache: false,
                success: function (data) {
                    button.attr('disabled', false);
                    backButton.attr('disabled', false);
                    button.find('.fa').show();
                    button.find('.fa-spinner').hide();

                    if (data.success) {
                        $('#gi-tab-2-errors').hide(200);
                        $("#program-names .program-name-item").remove();

                        let options = '';
                        for (let key in googleImport.three.dropdownProgramNames) {
                            options += '<option value="' + googleImport.three.dropdownProgramNames[key] + '">' + googleImport.three.dropdownProgramNames[key] + '</option>';
                        }

                        for (let key in googleImport.three.programNames) {
                            let custom = $("#program-names .custom-program-name").clone();
                            custom.find('.input-area input').val(googleImport.three.programNames[key]);
                            custom.find('.input-area input').attr('data-old_value', googleImport.three.programNames[key]);
                            custom.addClass('program-name-item');
                            custom.addClass('d-flex');
                            custom.removeClass('custom-program-name');
                            custom.removeClass('d-none');
                            custom.find('.select-area select').append($(options));
                            custom.find('.description-area span').html(googleImport.three.createdDates[key]);
                            $('#program-names').append(custom);
                        }

                        $("#program-names .program-name-item select").selectpicker();
                        $('#gi-tab-3-link').tab('show');
                    } else {
                        $('#gi-tab-2-errors').html(data.errors.join('<br>')).fadeIn();
                    }
                }
            });
        }
        else {
            $('#next-gi-tab-4').click();
        }
    });

    $(document).on('click', '#back-gi-tab-2', function (e) {
        e.preventDefault();
        $('#gi-tab-2-link').tab('show');
    });

    $(document).on('click', '#next-gi-tab-4', function (e) {
        e.preventDefault();

        let step = $('#gi-tab-3-link').hasClass('active') ? 3 : 2;

        let button = $(this);
        let backButton = $('#back-gi-tab-' + (step - 1));
        button.attr('disabled', true);
        backButton.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let action = button.data('action');
        let formData = new FormData();

        formData.append('market_id', googleImport.market['market_id']);
        formData.append('client_id', googleImport.client['client_id']);
        formData.append('header', JSON.stringify($('#csv-file-table-form').serializeArray()));
        formData.append('rows', JSON.stringify(googleImport.two.rows));

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function (data) {
                button.attr('disabled', false);
                backButton.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();

                if (data.success) {
                    $('#gi-tab-' + step + '-errors').hide(200);
                    googleImport.four.header = data['header'];
                    googleImport.four.rows = data['rows'];
                    displayLeadsToAdsTable();
                    $('#gi-tab-4-link').tab('show');
                } else {
                    $('#gi-tab-' + step + '-errors').html(data.errors.join('<br>')).fadeIn();
                }
            }
        });
    });

    $(document).on('click', '#back-gi-tab-3', function (e) {
        e.preventDefault();
        if (googleImport.three.programNames.length > 0) {
            $('#gi-tab-3-link').tab('show');
        } else {
            $('#gi-tab-2-link').tab('show');
        }
    });

    $(document).on('click', '#next-gi-tab-5', function (e) {
        e.preventDefault();

        let button = $(this);
        let backButton = $('#back-gi-tab-3');

        button.attr('disabled', true);
        backButton.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let action = button.data('action');
        let formData = new FormData();

        //Generating ad index fro leads
        let leads = $('#gi-tab-4-table .leads-to-ads tbody tr[data-is="lead"]');
        let leads_to_ads = {};
        leads.each(function () {
            leads_to_ads[$(this).data('index')] = $(this).data('ad_index');
        });

        formData.append('market_id', googleImport.market['market_id']);
        formData.append('client_id', googleImport.client['client_id']);
        formData.append('master_header', JSON.stringify($('#csv-file-table-form').serializeArray()));
        formData.append('master_rows', JSON.stringify(googleImport.two.rows));
        formData.append('header', JSON.stringify(googleImport.two.header));
        formData.append('leads_to_ads', JSON.stringify(leads_to_ads));

        let changedProgramNames = [];
        $("#program-names .program-name-item .input-area input").each(function () {
            if ($(this).val() !== $(this).data('old_value')) {
                changedProgramNames.push({
                    old_value: $(this).data('old_value'),
                    new_value: $(this).val()
                });
            }
        });
        formData.append('changed_program_names', JSON.stringify(changedProgramNames));

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function (data) {
                button.attr('disabled', false);
                backButton.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();

                if (data.success) {
                    $('#gi-tab-5-messages').html(data['messages'].join('<br>')).fadeIn();
                } else {
                    $('#gi-tab-5-errors').html(data['errors'].join('<br>')).fadeIn();
                }

                $('#gi-tab-5-link').tab('show');
            }
        });
    });

    $('body').on('change', '#gi-tab-4-table .leads-to-ads select', function () {
        let adIndex = $('option:selected', this).data('index');
        $(this).parents('tr').attr('data-ad_index', adIndex);
    });

    //Google update
    $(document).on('click', '#leads-google-update-save', function (e) {
        e.preventDefault();

        let button = $(this);
        let backButton = $('#show-leads-google-update-form');

        button.attr('disabled', true);
        backButton.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let saveForm = $('#save-leads-google-update-form');
        let action = saveForm.attr('action');

        let selectedHeader = $('#csv-file-table-form').serializeArray();
        let advertIds = [];
        $('.autocomplete-inputs').each(function (k) {
            advertIds.push($(this).val());
        });

        let oldCrmLeadIds = [];
        $('#google-leads-update-table tbody tr td:last-child input').each(function () {
            oldCrmLeadIds.push({
                index: $(this).data('index'),
                value: $(this).val()
            });
        });

        $.ajax({
            type: 'POST',
            url: action,
            data: JSON.stringify({
                header: masterTableHeader,
                selected_header: JSON.stringify(selectedHeader),
                master_rows: JSON.stringify(masterTableRows),
                old_crm_lead_ids: JSON.stringify(oldCrmLeadIds),
                client_id: $('#import-client-id').val(),
                market_id: $('#import-market-id').val(),
                advert_ids: JSON.stringify(advertIds),
                master_id: $('#import-market-id').val(),
                mode: "update",
                spreadsheet_id: $('#google-sheet-input').val(),
                name: $('#sheet_name').val(),
            }),
            processData: false,
            contentType: 'application/json',

            success: function (data) {
                button.attr('disabled', false);
                backButton.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();

                if (data.success) {
                    $('#csv-file-save-success-messages').html(data.messages.join('<br>')).fadeIn();
                    $('#csv-file-save-error-messages').hide(200);
                    $('#csv-file-messages-tab-link').tab('show');

                } else {
                    $('#csv-file-save-error-messages').html(data.errors.join('<br>')).fadeIn();
                }
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });

    $(document).on('click', '#show-leads-google-update-form', function (e) {
        $('#csv-file-form-tab-link').tab('show');
    });

    $(document).on('click', '#show-leads-google-update', function (e) {
        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        $('#csv-file-table').html('');

        let form = $('#lead-google-update-form');
        let action = form.attr('action');
        let formData = new FormData(form[0]);

        $.ajax({
            type: 'POST',
            url: action,
            enctype: 'multipart/form-data',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,

            success: function (data) {
                if (data.success) {
                    $('#csv-error-messages').hide(200);
                    $('#csv-file-table').html(data.table);
                    $('#csv-file-table-tab-link').tab('show');
                    $('#csv-file-save-info-messages').hide();
                    $('.container_large').addClass('mw-1500');

                    masterTableHeader = data.header;
                    masterTableRows = data.rows;

                    if (data.advertList) {
                        let advertNames = [];

                        for (let item of data.advertList) {
                            var quickArr = [item.ad_id, item.program_id, item.created];
                            advertNames.push(quickArr);
                        }

                        $('.autocomplete-inputs').each(function () {
                            autocomplete(this, advertNames);
                        });
                    }

                    if (data.client || data.marketId) {
                        messages = [];

                        if (data.client) {
                            messages.push(`Selected Client is ${data.client.client_name} (${data.client.client_id})`);
                        }
                        if (data.marketId) {
                            messages.push(`Selected Market ID is ${data.marketId}`);
                        }

                        $('#csv-file-save-info-messages').html(messages.join('<br>')).fadeIn();
                    }

                } else {
                    $('#csv-error-messages').html(data.errors.join('<br>')).fadeIn();
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();

                filterOptions();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });

    });

    //Csv header
    $(document).on('change', '.csv-table-header-select', filterOptions);

    function filterOptions() {
        let values = [];
        $('.csv-table-header-select').each(function () {
            if ($(this).val()) {
                values.push($(this).val())
            }
        });

        $('.csv-table-header-select option').each(function () {
            if (values.includes($(this).val())) {
                $(this).hide()
            } else {
                $(this).show()
            }
        })
    }
});
